import { useQueries } from '@tanstack/react-query'
import findFreeRoom from '@/v2/components/forms/Appointment/findFreeRoom'
import {
  appointmentWarningsKey,
  fetchAppointmentWarnings,
  getAppointmentFormat,
  getWarnings,
} from '@/v2/hooks/useCheckAppointmentWarnings'

// Runs the warnings check for every other room at the same time, so a booked
// room can be swapped for a free one. Shares the cache with
// useCheckAppointmentWarnings, so switching to the found room needs no request.
export const useFreeRoom = (appointment, roomsOptions, enabled) => {
  const otherRooms = roomsOptions.filter(
    room => String(room.value) !== String(appointment.roomId)
  )

  const results = useQueries({
    queries: otherRooms.map(room => {
      const formattedAppointment = getAppointmentFormat({
        ...appointment,
        roomId: room.value,
      })

      return {
        queryKey: appointmentWarningsKey(formattedAppointment),
        queryFn: () => fetchAppointmentWarnings(formattedAppointment),
        enabled,
      }
    }),
  })

  if (!enabled) return

  return findFreeRoom(
    otherRooms,
    results.map(({ isSuccess, data }) => ({
      isSuccess,
      warnings: getWarnings(data),
    }))
  )
}

export default useFreeRoom
